import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "w-full text-center p-2 font-extrabold text-sm" }, "Rit 2", -1)
const _hoisted_3 = { class: "rit1-table w-full table-fixed" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs font-extrabold text-grey p-2 break-words" }, "Nopol Bus"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs font-extrabold text-grey p-2 break-words" }, "No. Lambung"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs font-extrabold text-grey p-2 break-words" }, "Lokasi"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs font-extrabold text-grey p-2 break-words" }, "Pendapatan"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-xs font-extrabold text-grey p-2 break-words" }, "Jumlah Penumpang")
  ])
], -1)
const _hoisted_5 = { class: "text-center text-xs text-grey p-2 break-words" }
const _hoisted_6 = { class: "text-center text-xs text-grey p-2 break-words" }
const _hoisted_7 = { class: "text-center text-xs text-grey p-2 break-words" }
const _hoisted_8 = { class: "text-center text-xs text-grey p-2 break-words" }
const _hoisted_9 = { class: "text-center text-xs text-grey p-2 break-words" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center text-xs text-grey p-2"
}, "Tidak Ada Data", -1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "rit2-dashboard card-no-shadow" }, {
    content: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("table", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("tbody", null, [
                (_ctx.dataSource.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.dataSource, (data) => {
                      return (_openBlock(), _createElementBlock("tr", { key: data }, [
                        _createElementVNode("td", _hoisted_5, _toDisplayString(data.VehicleRegNumber), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(data.VehicleHullNumber), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(data.LastLocation), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.currencyNumberFormat(data.TotalIncome)), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(data.TotalTiketAmount), 1)
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_10, _hoisted_12))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}